import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tab } from 'react-bootstrap'; //  Col

import { userGroupUrlCheck } from '../../utils/userGroupUrlCheck';
import { checkPermissions } from '../../utils/permissions'; 

import { ROUTE_REFRESH, LOGIN_AFFILIATE_GROUP, LOGIN_SUPER_ADMIN_GROUP, ROUTE_SECTORS, ROUTE_SUB_SECTORS, ROUTE_OTHER_EXPENSES, ROUTE_OMNU_POINTS, ROUTE_OMNU_POINTS_SETTINGS, ROUTE_CANCEL_REASONS, ROUTE_ROLES_PERMISSIONS, ROUTE_TERMS_AND_CONDITIONS, ROUTE_AFFILIATE_SETTINGS, ROUTE_SA_SETTINGS, ROUTE_SKILLS, ROUTE_CREW_DOCS, ROUTE_DYNAMIC_FIELDS_CREW, ROUTE_DYNAMIC_FIELDS_AFFILIATES, ROUTE_CLIENT_DOCS, ROUTE_CLIENT_CATEGORY, ROUTE_DYNAMIC_FIELDS_CLIENTS, ROUTE_AFFILIATE_EVENT_LOCATIONS, ROUTE_AFFILIATE_KEY_LOCATIONS, ROUTE_AFFILIATE_DEPARTMENTS, ROUTE_AFFILIATE_VEHICLE_DETAILS, ROUTE_AFFILIATE_RATECARDS, ROUTE_AFFILIATE_PAY_LEVELS, ROUTE_AFFILIATE_OTHER_EXPENSES, ROUTE_AFFILIATE_CANCEL_REASONS, ROUTE_AFFILIATE_ROLES_PERMISSIONS, ROUTE_AFFILIATE_CSV_TEMPLATES, ROUTE_AFFILIATE_SKILLS, ROUTE_AFFILIATE_CREW_DOCS, ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW, ROUTE_AFFILIATE_CLIENT_DOCS, ROUTE_AFFILIATE_CLIENT_CATEGORY, ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS, ROUTE_AFFILIATE_PROFILE_MANAGE, ROUTE_PROFILE, ROUTE_TRAVEL_MODULE_FIELDS_AFFILIATES } from '../../configs/staticConfigs'; // ROUTE_BASIC_CONFIG, ROUTE_AFFILIATE_BASIC_CONFIG,

import { LBL_APP_NAME, LBL_SETTINGS, LBL_SECTORS, LBL_SUB_SECTORS, LBL_OTHER_EXPENSES, LBL_PP_POINTS, LBL_EVENT_CANCEL_REASONS, LBL_ROLES, LBL_PERMISSIONS, LBL_TERMS_AND_CONDITIONS, LBL_OMNU_POINTS_AGAINST_PP, LBL_BASIC_CONFIGS, LBL_SKILLS, LBL_CREW_DOCUMENTS, LBL_DYNAMIC_FIELDS_CREW, LBL_DYNAMIC_FIELDS_AFFILIATES, LBL_CLIENT_DOCUMENTS, LBL_CLIENT_CATEGORIES, LBL_DYNAMIC_FIELDS_CLIENTS, LBL_EVENT_LOCATIONS, LBL_KEY_LOCATIONS, LBL_DEPARTMENTS, LBL_VEHICLE_DETAILS, LBL_RATE_CARDS, LBL_PAY_LEVELS, LBL_CSV_TEMPLATES_DOWNLOAD, LBL_COMPANY_PROFILE, LBL_TRAVEL_MODULE_FIELDS_AFFILIATES, } from '../../configs/labelConfigs'; // LBL_FIELD_MANDATORY LBL_BACK_TO_BASIC_CONFIGS, 

import { clearAction } from '../../actions/commonActions';

class SettingsComponent extends Component {

    constructor(props) {
        super(props)

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = '';
        let userProfileId = '';
        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group;
            userProfileId = userGroupData.profile_id;
        }

        this.state = {
            activePage: LBL_BASIC_CONFIGS,
            userGroup: userGroup,
            userProfileId: userProfileId,
            headerText: LBL_BASIC_CONFIGS,
            commonErrMsg: '',
            showBasicConfigDet: true, 
        }

        let settingsMenu = [ ];
        if (userGroup === LOGIN_SUPER_ADMIN_GROUP) {
            settingsMenu.push({name:LBL_BASIC_CONFIGS,route:''}); 
            if(checkPermissions('companyprofile','view')){
                settingsMenu.push({name:LBL_COMPANY_PROFILE,route:ROUTE_PROFILE})
            }
            if(checkPermissions('sector','view')){
                settingsMenu.push({name:LBL_SECTORS,route:ROUTE_SECTORS})
            }if(checkPermissions('subsector','view')){
                settingsMenu.push({name:LBL_SUB_SECTORS,route:ROUTE_SUB_SECTORS})
            }if(checkPermissions('otherexpenses','view')){
                settingsMenu.push({name:LBL_OTHER_EXPENSES,route:ROUTE_OTHER_EXPENSES})
            }   
            if(checkPermissions('performancepoints','view')){
                settingsMenu.push({name:LBL_PP_POINTS,route:ROUTE_OMNU_POINTS})
            }if(checkPermissions('mnyhandspointsagainstpp','view')){
                settingsMenu.push({name:LBL_OMNU_POINTS_AGAINST_PP,route:ROUTE_OMNU_POINTS_SETTINGS})
            }if(checkPermissions('eventcancelreasons','view')){
                settingsMenu.push({name:LBL_EVENT_CANCEL_REASONS,route:ROUTE_CANCEL_REASONS})
            }if(checkPermissions('rolesandpermissions','view')){
                settingsMenu.push({name:LBL_ROLES+' & '+LBL_PERMISSIONS,route:ROUTE_ROLES_PERMISSIONS})
            }if(checkPermissions('termsandconditions','view')){
                settingsMenu.push({name:LBL_TERMS_AND_CONDITIONS,route:ROUTE_TERMS_AND_CONDITIONS})
            } 
        } else if (userGroup === LOGIN_AFFILIATE_GROUP) { 
            settingsMenu.push({name:LBL_BASIC_CONFIGS,route:''}); 
            if(checkPermissions('companyprofile','view')){
                settingsMenu.push({name:LBL_COMPANY_PROFILE,route:ROUTE_AFFILIATE_PROFILE_MANAGE})
            }
            if(checkPermissions('eventlocations','view')){
                settingsMenu.push({name:LBL_EVENT_LOCATIONS,route:ROUTE_AFFILIATE_EVENT_LOCATIONS})
            }
            if(checkPermissions('keylocations','view')){
                settingsMenu.push({name:LBL_KEY_LOCATIONS,route:ROUTE_AFFILIATE_KEY_LOCATIONS})
            }
            if(checkPermissions('settingsdepartments','view')){
                settingsMenu.push({name:LBL_DEPARTMENTS,route:ROUTE_AFFILIATE_DEPARTMENTS})
            } 
            if(checkPermissions('vehicleinfo','view')){
                settingsMenu.push({name:LBL_VEHICLE_DETAILS,route:ROUTE_AFFILIATE_VEHICLE_DETAILS})
            }
            if(checkPermissions('masterratecard','view')){
                settingsMenu.push({name:LBL_RATE_CARDS,route:ROUTE_AFFILIATE_RATECARDS})
            }
            if(checkPermissions('paylevels','view')){
                settingsMenu.push({name:LBL_PAY_LEVELS,route:ROUTE_AFFILIATE_PAY_LEVELS})
            }
            if(checkPermissions('otherexpenses','view')){
                settingsMenu.push({name:LBL_OTHER_EXPENSES,route:ROUTE_AFFILIATE_OTHER_EXPENSES})
            }
            if(checkPermissions('eventcancelreasons','view')){
                settingsMenu.push({name:LBL_EVENT_CANCEL_REASONS,route:ROUTE_AFFILIATE_CANCEL_REASONS})
            }
            if(checkPermissions('rolesandpermissions','view')){
                settingsMenu.push({name:LBL_ROLES+' & '+LBL_PERMISSIONS,route:ROUTE_AFFILIATE_ROLES_PERMISSIONS})
            }
            if(checkPermissions('csvtemplatesdownload','view')){
                settingsMenu.push({name:LBL_CSV_TEMPLATES_DOWNLOAD,route:ROUTE_AFFILIATE_CSV_TEMPLATES})
            }  
        }

        this.state = {
            settingsMenu:settingsMenu,
            activePage: LBL_BASIC_CONFIGS, 
            headerText: LBL_BASIC_CONFIGS,
            showBasicConfigDet: true, 
        }
    }

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = '';
        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group;
            this.setState({ userGroup: userGroup });
        }
        if (userGroup === LOGIN_AFFILIATE_GROUP) {
            document.body.classList.add('body-affiliate');
        }

        let groupId = 0;
        if (this.props.location.pathname === ROUTE_SA_SETTINGS) {
            groupId = LOGIN_SUPER_ADMIN_GROUP;
        } else if (this.props.location.pathname === ROUTE_AFFILIATE_SETTINGS) {
            groupId = LOGIN_AFFILIATE_GROUP;
        }
        
        document.title = LBL_APP_NAME + " - " + LBL_SETTINGS;
    }

    showHideBC = () => {
        this.setState({ showBasicConfigDet: !this.state.showBasicConfigDet });
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            let userGroupData = userGroupUrlCheck(this.props.location);
            let userGroup = '';
            if (userGroupData !== undefined) {
                userGroup = userGroupData.user_group;
            }
            let groupId = 0;
            if (this.props.location.pathname === ROUTE_SA_SETTINGS) {
                groupId = LOGIN_SUPER_ADMIN_GROUP;
            } else if (this.props.location.pathname === ROUTE_AFFILIATE_SETTINGS) {
                groupId = LOGIN_AFFILIATE_GROUP;
            }
            
            document.title = LBL_APP_NAME + " - " + LBL_SETTINGS;

        }
    }

    render() {

        const { status } = this.props;
        const { toastMessage, toastFlag, toastSuccess, settingsMenu } = this.state;

        if (status === 401 || status === 403) {
            return <Redirect to={ROUTE_REFRESH} />;
        }
        let userGroupData = userGroupUrlCheck(window.location);
        let lblCrew = 'Staff';
        let userGroup = ''; 

        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group; 
            if (userGroupData.staff_name) {
                lblCrew = userGroupData.staff_name;
            }
        }

        return (
            <React.Fragment>
                
                {userGroup==LOGIN_SUPER_ADMIN_GROUP ? <div className="col-md-8" >
                    <Tab.Container id="dynamicField-tab" defaultActiveKey="dynamicField-details-tab">
                        {/* <div className='col-12 divFloatLeft padding-left-20 padding-Bottom-5 font-14'><Link to={this.state.userGroup === LOGIN_AFFILIATE_GROUP ? ROUTE_AFFILIATE_BASIC_CONFIG : ROUTE_BASIC_CONFIG}>{LBL_BACK_TO_BASIC_CONFIGS}</Link> </div> */}
                        {/* <div className="box">
                                <div className="tab-head">
                                    <div className="text-bold normalText leftPanelHeading ">{categoriesHeading}</div>
                                </div>
                            </div> */}
                        {/* <div className="col-md-4 col-lg-3 col-xl-2 col-12">
                            <Nav variant="pills" className="nav flex-column nav-pills box">
                                {settingsMenu && settingsMenu.map((item, index) => {
                                    if (this.state.activePage === item.name) 
                                        return (<Nav.Link eventKey="dynamicField-details-tab" key={index} className='active basic-config-header' ><i className={item.icon_name}></i> {item.name}</Nav.Link>
                                    );
                                    else return (<Nav.Link key={index} onClick={(e) => this.state.activePage !== item.id ? this.changePage(e, item.id, item.name) : ''} ><i className={item.icon_name}></i> <small>{item.name}</small></Nav.Link>
                                    )
                                })}
                            </Nav>
                        </div> */}
                        
                        <div className="col-md-11 col-lg-11 col-xl-11 col-11 pl-0">
                            <Tab.Content>
                                <Tab.Pane eventKey="dynamicField-details-tab">
                                    {settingsMenu && settingsMenu.map((item, index) => {
                                        return(<div className="box">
                                            <div className="box-content"> 
                                                {item.name==LBL_BASIC_CONFIGS ? <div className='div-flex-left spanPointer' onClick={this.showHideBC}>
                                                <div className='basic-config-header'>{item.name}</div>
                                                <div class="padding-top-17"><i class={this.state.showBasicConfigDet ? "las la-angle-down la-lg padding-left-10" : "las la-angle-right la-lg padding-left-5"}></i></div></div> : <><Link to={item.route} className='basic-config-header'>{item.name}</Link></>}
                                                {(this.state.showBasicConfigDet && item.name==LBL_BASIC_CONFIGS) && <>
                                                    <div className="row">
                                                        <div className="col-1">
                                                            &nbsp; 
                                                        </div>
                                                        <div className="col-6">
                                                            <div className="row basic-config-header">General</div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_SKILLS}>{LBL_SKILLS}</Link></div>

                                                            <div className="row basic-config-header"><strong>Client</strong></div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_CLIENT_DOCS}>{LBL_CLIENT_DOCUMENTS}</Link></div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_CLIENT_CATEGORY}>{LBL_CLIENT_CATEGORIES}</Link></div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_DYNAMIC_FIELDS_CLIENTS}>{LBL_DYNAMIC_FIELDS_CLIENTS}</Link></div>
                                                            
                                                        </div>
                                                        <div className="col-5">
                                                            <div className="row basic-config-header"><strong>Affiliate</strong></div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_DYNAMIC_FIELDS_AFFILIATES}>{LBL_DYNAMIC_FIELDS_AFFILIATES}</Link></div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_TRAVEL_MODULE_FIELDS_AFFILIATES}>{LBL_TRAVEL_MODULE_FIELDS_AFFILIATES}</Link></div>
                                                            
                                                            <div className="row basic-config-header"><strong>Staff</strong></div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_CREW_DOCS}>{LBL_CREW_DOCUMENTS}</Link></div>
                                                            <div className="row basic-config-item" ><Link to={ROUTE_DYNAMIC_FIELDS_CREW}>{LBL_DYNAMIC_FIELDS_CREW}</Link></div>
                                                        </div>
                                                    </div>
                                                </>}
                                
                                            </div>
                                    </div>) }) }
                                </Tab.Pane> 
                                
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                </div> : <> </>}



                {userGroup==LOGIN_AFFILIATE_GROUP ? <div className="col-md-8" >
                    <Tab.Container id="dynamicField-tab" defaultActiveKey="dynamicField-details-tab">
                        {/* <div className='col-12 divFloatLeft padding-left-20 padding-Bottom-5 font-14'><Link to={this.state.userGroup === LOGIN_AFFILIATE_GROUP ? ROUTE_AFFILIATE_BASIC_CONFIG : ROUTE_BASIC_CONFIG}>{LBL_BACK_TO_BASIC_CONFIGS}</Link> </div> */}
                        {/* <div className="box">
                                <div className="tab-head">
                                    <div className="text-bold normalText leftPanelHeading ">{categoriesHeading}</div>
                                </div>
                            </div> */}
                        {/* <div className="col-md-4 col-lg-3 col-xl-2 col-12">
                            <Nav variant="pills" className="nav flex-column nav-pills box">
                                {settingsMenu && settingsMenu.map((item, index) => {
                                    if (this.state.activePage === item.name) 
                                        return (<Nav.Link eventKey="dynamicField-details-tab" key={index} className='active basic-config-header' ><i className={item.icon_name}></i> {item.name}</Nav.Link>
                                    );
                                    else return (<Nav.Link key={index} onClick={(e) => this.state.activePage !== item.id ? this.changePage(e, item.id, item.name) : ''} ><i className={item.icon_name}></i> <small>{item.name}</small></Nav.Link>
                                    )
                                })}
                            </Nav>
                        </div> */}
                        
                        <div className="col-md-11 col-lg-11 col-xl-11 col-11 pl-0">
                            <Tab.Content>
                                <Tab.Pane eventKey="dynamicField-details-tab">
                                    {settingsMenu && settingsMenu.map((item, index) => {
                                        return(<div className="box">
                                            <div className="box-content"> 
                                                {item.name==LBL_BASIC_CONFIGS ? <div className='div-flex-left spanPointer' onClick={this.showHideBC}>
                                                <div className='basic-config-header'>{item.name}</div>
                                                <div className="padding-top-17"><i class={this.state.showBasicConfigDet ? "las la-angle-down la-lg padding-left-10" : "las la-angle-right la-lg padding-left-5"}></i></div></div>: <><Link to={item.route} className='basic-config-header'>{item.name}</Link></>}
                                                {(this.state.showBasicConfigDet && item.name==LBL_BASIC_CONFIGS) && <>
                                                    <div className="row">
                                                        <div className="col-1">
                                                            &nbsp; 
                                                        </div>
                                                        <div className="col-6">
                                                            <div className="row basic-config-header">General</div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_AFFILIATE_SKILLS}>{LBL_SKILLS}</Link></div>
                                                            <div className="row basic-config-header"><strong>Staff</strong></div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_AFFILIATE_CREW_DOCS}>{LBL_CREW_DOCUMENTS}</Link></div>
                                                            <div className="row basic-config-item" ><Link to={ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW}>{LBL_DYNAMIC_FIELDS_CREW}</Link></div>
                                                        </div>
                                                        <div className="col-5">
                                                            <div className="row basic-config-header"><strong>Client</strong></div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_AFFILIATE_CLIENT_DOCS}>{LBL_CLIENT_DOCUMENTS}</Link></div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_AFFILIATE_CLIENT_CATEGORY}>{LBL_CLIENT_CATEGORIES}</Link></div>
                                                            <div className="row basic-config-item"><Link to={ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS}>{LBL_DYNAMIC_FIELDS_CLIENTS}</Link></div>
                                                        </div>
                                                    </div>
                                                </>} 
                                
                                            </div>
                                    </div>) }) }
                                </Tab.Pane> 
                                
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                </div> : <> </>}
                
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.dynamicFields.status,
        activity: state.dynamicFields.activity,
        errorData: state.dynamicFields.errorData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        clearAction: clearAction,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(SettingsComponent);